import { atom } from "recoil";

export const observerState = atom<IntersectionObserver>({
  key: "observerState",
  default: undefined,
});

export const observerEntriesState = atom<Array<IntersectionObserverEntry>>({
  key: "observerEntriesState",
  default: undefined,
});

export const detailKeyValueState = atom<{
  isModalOpen: boolean;
  isAnimation: boolean;
  serviceDetailKey: string;
}>({
  key: "detailKeyValue",
  default: {
    isModalOpen: false,
    isAnimation: false,
    serviceDetailKey: "SGSG",
  },
});

export const estimateModalState = atom<{
  isModalOpen: boolean;
}>({
  key: "estimateModal",
  default: {
    isModalOpen: false,
  },
});
